import { OEButton } from '@openeducation/oe-it-components';
import { useNotificationContext } from '@openeducation/oe-it-providers';
import { GenericNotification } from '@openeducation/oe-it-shared-types';

import { Banner } from '../../atoms/banner/banner';
import { useJoinClass } from '../../hooks/use-join-class';
import { useMessages } from '../../hooks/use-messages';

export interface NotificationGenericBannerProps {
  notification: GenericNotification;
}
export const NotificationGenericBanner = ({
  notification,
}: NotificationGenericBannerProps) => {
  const { joinClass } = useJoinClass({
    url: notification.url,
  });

  const { acknowledgeNotification } = useNotificationContext();
  const { remove } = useMessages();

  const handleAccept = () => {
    acknowledgeNotification(notification.id);
    joinClass();
  };

  if (notification.type === 'GenericNotification') {
    return (
      <Banner
        onDismiss={() => remove(notification.id)}
        title={notification.notification}
        type="warning"
      />
    );
  }
  return (
    <Banner
      title={notification.notification}
      message={`Classroom: '${notification.classTitle}'.`}
      type="warning"
      actions={
        <OEButton type="danger" onPress={handleAccept}>
          Accept
        </OEButton>
      }
    />
  );
};
